import { ILanguage } from "./ILanguage";

export class French implements ILanguage {
    logoutConfirmationMessage: string = "Êtes-vous sûr de vouloir vous déconnecter ? Cela mettra fin à votre session d'examen en cours";
    networkFair: string= "Moyen : Vous pouvez rencontrer un léger décalage, mais si le réseau ne se dégrade pas, vous ne devriez pas rencontrer de problèmes de réseau";
    networkPoor: string = "Mauvais : Vous risquez de rencontrer des problèmes de réseau lors de la passation de l'examen";
    networkGood: string = "Bon : Le réseau semble bon. Si les choses restent les mêmes, vous ne devriez pas rencontrer de problèmes de réseau";
    networkCheck: string = "Vérification du réseau";
    latency: string = "Latence";
    speed: string = "Vitesse";
    category: string ="Catégorie";
    goBack: string = "Retourner";
    unansweredQuestions: string = "Questions sans réponse";
    answeredQuestions: string = "Questions répondues";
    questionList: string = 'Liste de questions';
    systemCheck: string = "Exécuter la vérification du système";
    desktop: string = "Bureau";
    mobile: string = "Mobile";
    unknown: string = "Inconnu";
    selectLanguage: string = "Sélectionner la langue";
    languageName = "Français";
    submitConfirmationMessage: string = "Êtes-vous sûr de vouloir soumettre ? Cela mettra fin à l'examen";
    backToLogin: string = "Retour à la connexion";
    allComplaints: string = "Toutes les plaintes";
    complaintID: string = "ID de la plainte";
    examNo: string = "Numéro d'examen";
    lastName: string = "Nom de famille";
    firstName: string = "Prénom";
    status: string = "Statut";
    submittedDate: string = "Date de soumission";
    noComplaint: string = "Aucune plainte trouvée";
    complaint: string = "Plainte";
    selectExamComplaint: string = "Veuillez sélectionner l'examen pour lequel vous souhaitez déposer une plainte.";
    natureOfComplaint: string = "Veuillez sélectionner la nature de votre plainte.";
    closeComplaints: string = "Fermer la plainte";
    closeReply: string = "Fermer la réponse";
    replyComplaint: string = "Répondre à la plainte";
    reply: string = "Réponse";
    enterResponseDetails: string = "Entrez les détails de votre réponse";
    submit: string = "Soumettre";
    supportDiscussion: string = "Discussion de support";
    admin: string = "Admin";
    you: string = "Vous";
    complaintsClosed: string = "Plaintes fermées";
    replySent: string = "Réponse envoyée";
    candidateInformation: string = "Informations sur le candidat";
    viewAllComplaints: string = "Voir toutes les plaintes";
    examinationSelection: string = "Sélection de l'examen";
    complaintsDisabled: string = "Aucun examen trouvé ou les plaintes ont été désactivées pour cet examen";
    complaintCategory: string = "Catégorie de plainte";
    selectOption: string = "Sélectionner une option";
    complaintDetails: string = "Détails de la plainte";
    solvedYourIssue: string = "Le processus ci-dessus a-t-il résolu votre problème ?";
    yes: string = "Oui";
    no: string = "Non";
    enterComplaintDetails: string = "Entrez les détails de votre plainte";
    previous: string = "Précédent";
    cancel: string = "Annuler";
    next: string = "Suivant";
    limitOf: string = "Limite de";
    wordsMaximum: string = "mots maximum";
    welcome: string = "Bienvenue";
    logout: string = "Déconnexion";
    passportSection: string = "SECTION DU PASSEPORT";
    maxFileUpload1mb: string = "Taille maximale de téléchargement de fichier : 1 Mo";
    takePicture: string = "Prendre une photo";
    clearFaceInstruction: string = 'Assurez-vous que votre visage est CLAIREMENT visible dans le cercle ci-dessus en tout temps.';
secondViewClarityInstruction: string = 'Assurez-vous que votre profil et votre écran sont clairement visibles dans la vidéo ci-dessus. Veillez à suivre les instructions de l\'examen.';
    brightLightInstruction: string = "Veuillez vous assurer qu'il n'y a pas de lumière vive ou de fenêtres derrière vous.";
    requestAttention: string = "Demander de l'attention";
    uploadPassport: string = "Télécharger le passeport";
    unableToConnectToServer: string = "Impossible de se connecter au serveur. Veuillez vérifier votre connexion Internet ou redémarrer votre modem Internet";
    waitForProctorOk: string = "Veuillez attendre que le surveillant vous contacte";
    passportChangeErr: string = "Le passeport ne peut pas être modifié après le début de l'examen";
    uploadSuccessful: string = "Téléchargement réussi";
    savePassport: string = "Enregistrer le passeport";
    changePassport: string = "Changer de passeport";
    examinationFeedBack: string = "Retour d'information sur l'examen";
    happy: string = "Content";
    neutral: string = "Neutre";
    unhappy: string = "Mécontent";
    close: string = "Fermer";
    problemCategories: string = "Catégories de problèmes";
    othersProblemCategories: string = "Autres (veuillez fournir des détails)";
    login: string = "Connexion";
    username: string = "Nom d'utilisateur";
    password: string = "Mot de passe";
    makeComplaint: string = "Déposer une plainte";
    loggedOut: string = "Vous êtes déconnecté";
    userMis_match: string = "Incompatibilité de l'utilisateur. Accès non autorisé";
    loginToTakeExam: string = "Connectez-vous pour passer l'examen";
    aboutUs: string = "À propos de nous";
    //
    error: string = "Erreur";
    somethingWentWrong: string = "Oups ! Quelque chose s'est mal passé.";
    pleaseConatctAdministrator: string = "Veuillez contacter l'administrateur";
    instructions: string = "Instructions";
    question: string = "Question";
    pleaseHold: string = "VEUILLEZ PATIENTER";
    examHasBeenPaused: string = "VOTRE EXAMEN A ÉTÉ MIS EN PAUSE";
    reason: string = "RAISON";
    willNotLoseTime: string = "PENDANT CETTE PÉRIODE, VOUS NE PERDREZ PAS DE TEMPS CAR VOTRE MINUTEUR D'EXAMEN A ÉTÉ MIS EN PAUSE";
    userSessionNotFound: string = "Session utilisateur introuvable";
    networkConnectionLost: string = "Connexion réseau perdue. Tentative de reconnexion";
    multipleLoginsDetected: string = "Connexions multiples détectées";
    unauthorizedAccess: string = "Accès non autorisé";
    penalizedWarning: string = "Vous n'êtes pas autorisé à quitter la page de l'examen. Le faire entraînera une pénalité";
    youHaveLost: string = "Vous avez perdu";
    leavingExamPage: string = "minutes en tant que pénalité pour avoir quitté la page de l'examen";
    finishAndSubmit: string = "Terminer/Soumettre";
    questionHasBeen: string = "La question a été";
    verifyingEmail: string = "Vérification de l'e-mail";
    registration: string = "Inscription";
    emailAddress: string = "Adresse e-mail";
    verifyEmailAddress: string = "Vérifiez l'adresse e-mail";
    otherNames: string = "Autres noms";
    phoneNumber: string = "Numéro de téléphone";
    gender: string = "Genre";
    selectGender: string = "Sélectionner le genre";
    male: string = "Homme";
    female: string = "Femme";
    scheduleDate: string = "Date prévue";
    scheduleTime: string = "Heure prévue";
    selectTime: string = "Sélectionner l'heure";
    noAvailableTime: string = "Aucune heure disponible";
    noAvailableDate: string = "Aucune date disponible";
    register: string = "S'inscrire";
    registrationSuccessful: string = "Inscription réussie";
    yourRegistrationFor: string = "Votre inscription pour";
    wasSuccessful: string = "a été réussie.";
    yourExaminationNumberIs: string = "Votre numéro d'examen est";
    checkYourEmailForMoreInformation: string = "Vérifiez votre e-mail pour plus d'informations sur l'examen.";
    imageSizeIsGreaterthan1mb: string = "La taille de l'image est supérieure à 1 Mo.";
    invalidImageFormat: string = "Format d'image invalide";
    pleaseSelectGender: string = "Veuillez sélectionner un genre";
    pleaseFillExaminationSchedule: string = "Veuillez remplir les détails de la programmation de l'examen";
    pleaseUploadPassportPicture: string = "Veuillez télécharger la photo du passeport";
    registrationComplete: string = "Inscription terminée";
    verificationEmailSent: string = "Un e-mail de vérification a été envoyé à";
    invalidEmail: string = "E-mail invalide";
    emailVerified: string = "E-mail vérifié";
    invalidCode: string = "Code invalide";
    unavailableDateSelected: string = "Date indisponible sélectionnée";
    examPlatformUsageInst: string = "INSTRUCTIONS D'UTILISATION DE LA PLATEFORME D'EXAMEN";
    useSafeExamBrowser: string = "Pour passer cet examen, vous devrez utiliser le navigateur sécurisé (SEB). Suivez les instructions ci-dessous.";
    installSafeExamBrowser: string = "Si vous ne l'avez pas encore installé, veuillez utiliser le lien approprié ci-dessous pour le télécharger. Si vous l'avez déjà installé.";
    //ensureCurrentSEBVersionIsInstalled: string = "Veuillez vous assurer que vous avez la version actuelle installée.";
    sebUsageInstructionsSkipStep3: string = "Si vous avez déjà installé la version actuelle, vous pouvez passer à l'étape 3.";
    sebDownloadLinkForWindows: string = "Téléchargement de Secure Exam Browser pour Windows";
    sebDownloadLinkForMac: string = "Téléchargement de Secure Exam Browser pour Mac";
    installTheSoftware: string = "Une fois téléchargé, installez le logiciel.";
    onceSEBIsInstalled: string = "Une fois SEB installé, cliquez";
    here: string = "ici";
    downloadSEBexamfileforyourexam: string = "pour télécharger le fichier SEB pour votre examen.";
    youshouldseefile: string = "Vous devriez voir un fichier qui ressemble à ceci";
    double_clickdownloadedfile: string = "Double-cliquez sur le fichier téléchargé pour lancer votre examen.";
    confirmInstallSafeExamBrowser: string = "Remarque : Si le fichier d'examen SEB ne fonctionne pas, veuillez vérifier que vous avez correctement installé SEB et que vous utilisez le bon fichier téléchargé via le lien ci-dessus.";
    //unabletoconnecttoserver: string = 'Impossible de se connecter au serveur';
    connectionError: string = 'Erreur de connexion';
    unknownserversideerror: string = 'Erreur côté serveur inconnue';
    youhavebeenpreventedfromstarting: string = "Vous avez été empêché de commencer l'examen parce que";
    connectiontomediaserverlost: string = 'Connexion au serveur média perdue. Veuillez vous reconnecter';
    verificationError: string = "Une erreur de vérification s'est produite sur votre système. Si ce problème persiste, actualisez la page ou redémarrez votre navigateur";
    unexpectedCondition: string = 'Condition inattendue. exception markanswerasync';
    loading: string = 'Chargement';
    submitExamination: string = "SOUMETTRE L'EXAMEN";

    submitting: string = 'Soumission en cours';
    yourScore: string = 'Votre score est';
    startNewExam: string = 'Commencer un nouvel examen';
    takeExam: string = "Passer l'examen";
    join: string = 'Rejoindre';
    minutes: string = 'minutes';
    start: string = 'Commencer';
    continue: string = 'Continuer';
    scheduleExam: string = 'Programmer un examen';
    pleaseWait: string = 'Veuillez patienter';
    finished: string = 'Terminé';
    timeElapsed: string = 'Temps écoulé';
    disqualified: string = 'Disqualifié';
    stopped: string = 'Arrêté';
    reschedule: string = "Reprogrammer";
    webtestInstruction: string = "INSTRUCTIONS D'UTILISATION";
    agreeToInstructions: string = 'Je reconnais avoir lu et compris les instructions ci-dessus';
    startExam: string = "Commencer l'examen";
    examSchedule: string = 'Programmation des examens';
    selectDate: string = 'Sélectionner une date';
    schedule: string = 'Programmer';
    examScheduled: string = 'Examen programmé. Veuillez vérifier votre e-mail';
    examinationList: string = 'Liste des examens';
    scheduledExaminations: string = 'Examens programmés';
    ensureyourfacefillsthecircle: string = 'Gardez une expression neutre. Assurez-vous que votre visage remplisse 90 % du cercle. Vérifiez également que l\'objectif de votre caméra soit propre';
    smileForASecondPhoto: string = 'Souris pour une deuxième photo';
    capturePhoto: string = 'Capturer une photo';
    captureSmilingPhoto: string = 'Prendre une photo souriante';
    startOver: string = 'Recommencer';
    upload: string = 'TÉLÉCHARGER';
    save: string = 'Enregistrer';
    youhavenooutputvideodevice: string = 'Aucun appareil vidéo de sortie détecté';
    errorloadingcustomcssfile: string = 'Erreur lors du chargement du fichier CSS personnalisé';
    noExamsFound: string = 'Aucun examen trouvé';
    multipleChoice: string = "Choix multiple";
    interview: string = "Entretien";
    essay: string = "Dissertation";
    flagged: string = "Signalé";
    unflagged: string = "Non signalé";
    duplicateCameratyprDetected: string = "Plusieurs types de caméras détectés";
    errorCheckingDuplicateCameras: string = "Erreur lors de la vérification des caméras en double";
    itRecommendedUseDesktopDevice: string = "Il est recommandé d'utiliser un appareil de bureau pour ce système de surveillance.";
    virtualMachineDetected: string = "Machine virtuelle détectée et en cours d'exécution.";
    noWorkingCamerafound: string = "Aucune caméra fonctionnelle trouvée.";
    failedToAccessCamera: string = "Échec de l'accès à la caméra :";
    noWorkingMicrophoneFound: string = "Aucun microphone fonctionnel trouvé.";
    failedToAccessMicrophone: string = "Échec de l'accès au microphone :";
    failedToPlaySound: string = "Échec de la lecture du son :";
    failedToEnumerateDevices: string = "Échec de l'énumération des appareils : ";
    developerToolsAreOpen: string = "Les outils de développement sont ouverts";
    available: string = "Disponible";
    notAvailable: string = "Indisponible";
    proctoringSystemCheck: string = "Vérification du système de surveillance";
    camera: string = "Caméra";
    speaker: string = "Haut-parleur";
    microphone: string = "Microphone";
    recording: string = "Enregistrement";
    osVersion: string = "Version du système d'exploitation";
    browserVersion: string = "Version du navigateur";
    deviceType: string = "Type d'appareil";
    virtualMachine: string = "Machine virtuelle";
    safeExamBrowser: string = "Navigateur sécurisé (SEB)";
    runCheck: string = "Lancer la vérification";
    mediaChecks: string = "Vérifications des médias";
    cameraCheck: string = "Vérification de la caméra";
    microphoneCheck: string = "Vérification du microphone";
    speakerCheck: string = "Vérification du haut-parleur";
    playTestSound: string = "Lire le son de test";
    playingTestSound: string = "Lecture du son de test";
    unknownBrowser: string = "Navigateur inconnu";
    unknownVersion: string = "Version inconnue";
    notUsed: string = "Non utilisé";
    used: string = "Utilisé";
    detected: string = "Détecté";
    notDetected: string = "Non détecté";
    canHearBeepSound: string = "Avez-vous entendu le son ?";
    canSeeSelf: string = "Pouvez-vous vous voir clairement ?";
    audioNotAvailablePlease: string = "L'audio n'est pas disponible. Veuillez vérifier le volume ou réessayer.";
    cameraNotAvailablePlease: string = "La caméra n'est pas disponible. Veuillez vérifier les paramètres ou réessayer.";
    retakeExam: string = "Reprendre l'examen";
    reasonForRetake: string = "Raison pour reprendre l'examen";
    shortAnswerQuestion: string= "Question à réponse courte";
    sebMinimumOSVersionWindows: string = "Windows 8.1 ou une version ultérieure requise";
    sebMinimumOSVersionMac: string = "macOS Ventura ou une version ultérieure requise";
    abbreviatedQuestionNo: string = "Q. Non";
    toggleCalculator: string = "Basculer la calculatrice";
    scoreFetchError: string = "Impossible de récupérer le score, votre administrateur publiera votre score plus tard";
    postSubmitScoreFetching: string = "Soumission réussie, veuillez patienter pour voir votre score...";
    installSebIfNotInstalled: string = "Si vous n'avez pas installé SEB (Secure Exam Browser), veuillez suivre les instructions correspondant à votre système d'exploitation ci-dessous pour l'installer. ";
    ifInstalledSebTakeYourExam: string = "Si vous avez déjà la dernière version de SEB installée, ";
    clickHereToTakeYourExam: string = "Cliquez ici pour passer votre examen. ";
    ifDirectStartLinkDoesNotWOrk: string = "Si le lien pour commencer votre examen ne fonctionne pas, veuillez télécharger le fichier d'examen SEB pour votre examen en cliquant ";
    grantSebAllPermissions: string = "Accordez toutes les autorisations demandées à SEB";
    furtherInstallationAssistanceneeded: string = "Si vous avez besoin d'aide supplémentaire pour commencer votre examen, veuillez regarder la vidéo ci-dessous :";
    clickToDownloadSEB: string = "Cliquez ici pour télécharger SEB";
    ifInstallationOrStartupOfSEBFails: "Si l'installation ou le démarrage de SEB échoue, vous devrez peut-être effectuer tout ou partie des étapes suivantes avant de continuer";
    disableOrUninstallYourAntivirus: "Désactivez/Désinstallez votre antivirus";
    reasonToDisableAntivirusesForSEB: "Certains antivirus sont connus pour interférer avec l’installation et l’utilisation normales de SEB. Vous devrez peut-être désinstaller complètement l’antivirus pour continuer.";
    downloadAndInstallVisualCPP: "Téléchargez et installez Visual C++";
    clickHereToDownloadVisualCPP: "Cliquez ici pour télécharger Visual C++.";
    downloadAndInstallDotNetFramework: "Téléchargez et installez .NET Framework";
    clickHereToDownloadAndInstallDotNetFramework: "Cliquez ici pour télécharger .NET Framework.";
    updateYourOperatingSystem: "Mettez à jour votre système d'exploitation";
    instructionsToUpdateOperatingSystem: "Allez dans : Windows -> Rechercher des mises à jour";
    afterTakingTroubleshootingStepsTryReinstallingOrUsingSEB: string = "Once you have done the above, please try installing and using SEB again. If it continues to fail, you may need to use a different device.";
    viewExamInstruction: string = "Voir les instructions d'examen";
    quillEditorReadOnlyDefaultMessage: string = "Voir les instructions d'examen";
    quillEditorPlaceHolderMessage: string = "Tapez votre réponse";
    quillEditorEssayReadOnlyMessage: string = "Nombre maximal de questions répondues — voir les instructions d'examen !";
    clearAnswer: string = "Réponse claire";
    areYouSure: string = "Es-tu sûr?";
    undo: string = "défaire";
    redo: string = "refaire";
    insertTable: string = "Insérer un tableau";
    linkedExaminations: string = "Examens liés";
    youHaveCompleted: string = "Vous avez terminé";
    continueWith: string = "Continuer avec";
    goBackToLoginPage: string = "Retourner à la page de connexion";
    listOfComplaints: string = "Liste des plaintes";
    goToDashboard: string = "Aller au tableau de bord des examens";
    zoomControls: string = "Contrôles de zoom";
    zoomIn: string = "Zoomer pour agrandir le texte";
    zoomOut: string = "Dézoomer pour réduire la taille du texte";
    remaining: string = "restante";
    and: string = "et";
    seconds: string = "secondes";
    logoutFromTheCurrentSession: string = "Se déconnecter de la session actuelle";
    passport: string = "Passeport";
    openWebcamForPassport: string = "Ouvrir la webcam pour prendre une photo de passeport";
    closeCapturePhotoDialog: string = "Fermer la boîte de dialogue de capture photo";
    closeFeedbackModal: string = "Fermer la boîte de dialogue de commentaires";
    happyFeedback: string = "Commentaire positif";
    neutralFeedback: string = "Commentaire neutre";
    unhappyFeedback: string = "Commentaire négatif";
    provideMoreDetails: string = "Fournir plus de détails sur le problème sélectionné";
    loginHomepage: string = "Page d'accueil de connexion";
    webtestLoginPic: string = "Image de connexion WebTest";
    companyBadgePic: string = "Image du badge de l'entreprise";
    submitLoginForm: string = "Soumettre le formulaire de connexion";
    clickToLogin: string = "Cliquer pour se connecter";
    helpfulLinks: string = "Liens utiles";
    visitWebtestWebsite: string = "Visiter le site webtest.ng";
    webTestLogo: string = "Web Test";
    questionContent: string = "Contenu de la question";
    loadingQuestionWait: string = "Chargement de la question, veuillez patienter...";
    subQuestions: string = "Sous-questions";
    subQuestion: string = "Sous-question";
    questionIs: string = "est";
    questionSection: string = "Section de la question";
    flagQuestionToRevisit: string = "Marquer une question pour la revoir plus tard";
    closeCalculator: string = "Fermer la boîte de dialogue de la calculatrice";
    selectOneOption: string = "Sélectionner une option";
    selectAllThatApply: string = "Sélectionner tout ce qui s'applique";
    questionNavigation: string = "Navigation des questions";
    goToQuestion: string = "Aller à la question";
    previousQuestion: string = "Question précédente";
    nextQuestion: string = "Question suivante";
    youAreOnTheLastQuestion: string = "Vous êtes sur la dernière question";
    richTextEditor: string = "Éditeur de texte riche pour la saisie des réponses";
    clearTextConfirmation: string = "Confirmation d'effacement du texte";
    clearTextConfirmationDescription: string = "Cette action supprimera définitivement tout le texte dans l'éditeur. Voulez-vous continuer ?";
    confirmClearText: string = "Oui, effacer tout le texte";
    cancelClearText: string = "Non, conserver le texte";
    quillAnswerInputInstruction: string = "Utilisez cet éditeur de texte riche pour saisir votre réponse. Vous pouvez formater le texte en utilisant la barre d'outils";
    answerArea: string = "Zone de réponse";
    typeInYourAnswer: string = "Tapez votre réponse";
    scrollToBottom: string = "Faire défiler vers le bas";
    scrollToTop: string = "Faire défiler vers le haut";
    loadingWait: string = "Chargement, veuillez patienter";
    loadingCheck: string = "Chargement, vérification du système";
    cameraPreview: string = "Aperçu de la caméra";
    joinInterviewExam: string = "Rejoindre l'examen d'entretien";
    takeInterviewExamSEB: string = "Passer l'examen d'entretien (SEB)";
    takeExamSEB: string = "Passer l'examen (SEB)";
    continueExam: string = "Continuer l'examen";
    continueExamSEB: string = "Continuer l'examen (SEB)";
    examType: string = "Type d'examen";
    examDuration: string = "Durée de l'examen";
    loadingSpinner: string = "Chargement...";
    errorDetails: string = "Cliquez pour afficher les détails de l'erreur pour examen";
    liveVideoFeed: string = "Flux vidéo en direct pour la capture du visage";
    capturedPhotoThumbnail: string = "Miniature de la photo capturée";
    enter: string = "Entrer";
    closeRetakeDialog: string = "Fermer la boîte de dialogue de reprise";
    quitSebMessage: string = "Vous pouvez utiliser ce bouton pour quitter à tout moment";
    quitSeb: string = "Quitter la session du navigateur d'examen sécurisé";
    exam: string = "examen";
    questionNo: string = "Question n°";
    examDate: string = "Date de l'examen";
    checkQuality: string = "Vérifier la qualité";
    analyzingImage: string = "Analyse de l'image...";
    processingFaceDetection: string = "Traitement de la détection de visage...";
    checkingImageQuality: string = "Vérification de la qualité de l'image...";
    almostDone: string = "Presque terminé...";
    finalizingAnalysis: string = "Finalisation de l'analyse...";
    faceNotDetectedInstruction: string = 'Visage non détecté. Assurez-vous que votre caméra est propre et que vous êtes dans une pièce éclairée sans source de lumière derrière vous.';
    multipleFacesDetectedInstruction: string = 'Plusieurs visages détectés. Veuillez vous assurer que vous êtes la seule personne visible sur la caméra.';
    poorQuality: string = 'Mauvaise';
    warningQuality: string = 'Attention';
    goodQuality: string = 'Bonne';
    errorConnectingToAiProctorServer: string = 'Une erreur s\'est produite. Impossible de se connecter au serveur';
    faceMismatchPleaseRetakeThePicture: string = 'Les photos ne correspondaient pas parfaitement. Veuillez les reprendre';
    pleaseKeepANeutralExpressionForTheFirstPhoto: string = 'Veuillez garder une expression neutre pour la première photo';
    pleaseSmileForTheSecondPhoto: string = 'Veuillez sourire pour la deuxième photo';
    pleaseEnsureYourFaceFillsTheCircleWhenTakingThePicture: string = 'Veuillez vous assurer que votre visage remplisse le cercle lorsque vous prenez la photo. Essayez de vous rapprocher de la webcam';
    tryCleaningTheCameraLensAndMovingCloserToTheScreen: string = 'Essayez de nettoyer l\'objectif de votre caméra et de vous rapprocher de l\'écran. Assurez-vous également que votre visage n\'est pas obstrué par un objet, y compris vos mains. Gardez votre visage visible dans le cercle en tout temps';
    startingYourExam: string = 'Démarrage de votre examen';
    pleaseWaitWhileWeAuthenticateYouAndStartYourExam: string = 'Veuillez patienter pendant que nous vous authentifions et que nous démarrons/poursuivons votre examen';
    startingExamKeepEyesOnTheScreen: string = 'Gardez les yeux ouverts et fixés sur l\'écran, et assurez-vous que votre visage est entièrement visible dans le cercle et qu\'il occupe au moins 80 % du cercle ci-dessous';
    primaryRecordingVerificationFailureMessage: string = 'Échec du streaming vidéo. Veuillez vérifier votre connexion Internet et/ou redémarrer votre modem';
    secondViewRecordingVerificationFailureMessage: string = 'La diffusion vidéo de la seconde vue a échoué. Veuillez vérifier la connexion Internet de votre (vos) appareil(s) et/ou redémarrer votre modem. Si vous utilisez un appareil mobile, assurez-vous qu\'il est toujours allumé et connecté à Internet';
    paused: string = 'pause';
    failureToComplyMayResultInDisqualification: string = 'Le non-respect peut entraîner une disqualification';
    compulsoryQuestion: string = "QUESTION OBLIGATOIRE";
}
